import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { zodValidator } from '@tanstack/zod-adapter'
import { Suspense } from 'react'
import { VerifyEmail } from '@/components/auth/verify-email/verify-email'
import GenieLogo from '@/components/ui/icon/icons/GenieLogo'

const verifyEmailSearchSchema = z.object({
  token: z.string().optional(),
  email: z.string().optional(),
  // Better Auth appends `?error=CODE` to the callbackURL when it handled the link itself and the
  // token turned out to be expired or invalid. Without this the code is stripped here and the
  // page cannot tell the user why the link did not work.
  error: z.string().optional(),
  // Present when the emailed link came back here after Better Auth verified it server-side:
  // no token, no error, and the page the user was heading for. Its absence is what tells the
  // page that someone simply opened /verify-email by hand.
  redirect: z.string().optional(),
})

export const Route = createFileRoute('/_auth/verify-email')({
  validateSearch: zodValidator(verifyEmailSearchSchema),
  component: VerifyEmailPage,
})

function VerifyEmailPage() {
  return (
    <Suspense
      fallback={
        <div className="flex min-h-screen items-center justify-center">
          <div className="text-center flex flex-col items-center">
            <GenieLogo className="mb-6 h-12 w-12" />
            <p className="mb-4">Loading...</p>
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-foreground"></div>
          </div>
        </div>
      }
    >
      <VerifyEmail />
    </Suspense>
  )
}
